import variableColors from "@/base/global/variables/figma.colors.json";

export const badgeThemeToken: any = {
  //====================== COLOR ========================//
  colorInfo: variableColors["ColorFigmaComplementaryBlue50"],
  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorWarning: variableColors["ColorFigmaFunctionalWarning50"],
  colorError: variableColors["ColorFigmaProductaccentAccent0250"],
  colorBorderBg: variableColors["ColorFigmaProductaccentAccent0250"],

  //====================== FONT ========================//
  lineHeight: 16,
  textFontSize: 11,
  textFontSizeSM: 7,
  textFontWeight: 700,

  //====================== SIZE ========================//
  paddingXS: 0,
  lineWidth: 1,
  indicatorHeight: 15,
  indicatorHeightSM: 11,
};
